import { UnitsDataDto } from "./units.dto";
import { UnitsData } from "./units.entity";


export class UnitsDataAdapter {
    static convertDtoToEntity(dto: UnitsDataDto) {
        throw new Error('Method not implemented.');
    }
    public convertEntityToDto(unitsData: UnitsData): UnitsDataDto {
        const dto = new UnitsDataDto();
        dto.unitId = unitsData.unitId;
        dto.unitName = unitsData.unitName;
        dto.isActive = unitsData.isActive;
        dto.createdUser = unitsData.createdUser;
        dto.createdAt = unitsData.createdAt;
        dto.updatedAt = unitsData.updatedAt;
        dto.updatedUser = unitsData.updatedUser;
        dto.versionFlag = unitsData.versionFlag;
        return dto;
    }

    public convertDtoToEntity(data: UnitsDataDto): UnitsData {
        const entity = new UnitsData()
        entity.unitId = data.unitId;
        entity.unitName = data.unitName;
        entity.isActive = data.isActive;
        entity.createdAt = data.createdAt;
        entity.createdUser = data.createdUser;
        entity.updatedAt = data.updatedAt;
        entity.updatedUser = data.updatedUser;
        entity.versionFlag = data.versionFlag;
        return entity;
    }
}
